import {Component} from '@angular/core';
import {RouterOutlet} from '@angular/router';
import {LoaderComponent, ToasterComponent} from '@vallift/ngl';

@Component({
  selector: 'app-root',
  imports: [
    RouterOutlet,
    ToasterComponent,
    LoaderComponent,
    // ApiLoadTestPanelComponent,
  ],
  templateUrl: './app.html',
  styleUrl: './app.css'
})
export class App {
}
